import Service from "../abstract/service";

export default class Procedures extends Service {
  constructor() {
    super();
    this._proceduresCollection = this._db.collection(`Procedures`);
  }

  async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando Procedure')
      let doc = await this._proceduresCollection.doc()
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando procedures')
      const response = await this._proceduresCollection.get()

      let procedure = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          procedure.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(procedure)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(procedure) {
    try {
      let procedureRef = await this._proceduresCollection.doc(procedure.id);
      await procedureRef.update({
        ...procedure
      });
    } catch (error) {
      return Promise.reject(error);
    }

    return Promise.resolve("Usuário atualizado com sucesso!");
  }

  async delete(cpf) {
    try {
      await this._proceduresCollection.doc(cpf).delete();
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
